var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_2488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 40.5V38.1667H27.6667V35.8333H18.3334V19.5H41.6667V35.8333H32.3334V38.1667H34.6667V40.5H25.3334ZM20.6667 33.5H39.3334V21.8333H20.6667V33.5Z",
    fill: "#95A1C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6326 31.4786V27.9644H26.4217V31.4786H24.6326ZM27.6145 31.4786V25.4543H29.4036V31.4786H27.6145ZM30.5964 31.4786V26.9604H32.3855V31.4786H30.5964ZM33.5783 31.4786V23.9482H35.3674V31.4786H33.5783Z",
    fill: "#95A1C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_2488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuIcon02);
export default __webpack_public_path__ + "static/media/leftmenu_icon02.53b2f87f3928d6622bf6eb2a62f9a2a0.svg";
export { ForwardRef as ReactComponent };